import { useState } from "react";
import { AgGrid } from "@jsq/ds/core";
import { PageWrapper } from "../components/PageWrapper";
import Titlebar from "../components/Titlebar";
import { useAgGridUtils } from "../utils/gridUtils";
import CanopyRoleDetails from "./CanopyRoleDetails";
import CanopyRolesTable from "./components/CanopyRolesTable";
import { useFetchCanopyRolesData } from "./hooks";

export interface CanopyRoleData {
  id: string;
  title: string;
  memberCount: number;
}

const CanopyRolesPage: React.FC = () => {
  const [isRoleDetailsOpen, setIsRoleDetailsOpen] = useState(false);
  const [selectedIdx, setSelectedIdx] = useState<number>();
  const { rowData, useGetGroupsQueryResult } = useFetchCanopyRolesData();
  const { onGridReady, resetFilters, isFilterPresent, onFilterChanged } =
    useAgGridUtils<CanopyRoleData>();

  const onCellClicked = (event: AgGrid.CellClickedEvent<CanopyRoleData>) => {
    setSelectedIdx(event.rowIndex!);
    setIsRoleDetailsOpen(true);
  };

  return (
    <PageWrapper testId="canopy-roles-page" result={useGetGroupsQueryResult}>
      <Titlebar
        title="Canopy roles"
        variant="h2"
        marginBottom="lg"
        actionButtons={[
          {
            show: isFilterPresent,
            buttonProps: {
              variant: "neutral",
              icon: "times",
              key: "clear_filters",
              onClick: resetFilters,
              children: "Clear filters",
            },
          },
        ]}
      />
      <CanopyRolesTable
        onGridReady={onGridReady}
        rowData={rowData}
        onCellClicked={onCellClicked}
        onFilterChanged={onFilterChanged}
      />
      {isRoleDetailsOpen && (
        <CanopyRoleDetails
          isOpen={isRoleDetailsOpen}
          onClose={() => setIsRoleDetailsOpen(false)}
          title={rowData?.[selectedIdx!].title ?? ""}
          roleId={rowData?.[selectedIdx!]?.id ?? ""}
          groupsData={useGetGroupsQueryResult.data}
        />
      )}
    </PageWrapper>
  );
};

export default CanopyRolesPage;
